import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/home.vue"),
    meta: {
      title: "首页",
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/register.vue"),
    meta: {
      title: "注册",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/personalCenter",
    name: "PersonalCenter",
    component: () => import("@/views/personalCenter.vue"),
    meta: {
      title: "个人中心",
    },
  },
  {
    path: "/project/:id",
    name: "Project",
    component: () => import("@/views/project.vue"),
    meta: {
      title: "慈福项目",
    },
  },
  {
    path: "/projectDetail",
    name: "Project",
    component: () => import("@/views/projectDetail.vue"),
    meta: {
      title: "慈福项目详情",
    },
  },
  {
    path: "/donate/:id",
    name: "Donate",
    component: () => import("@/views/donate.vue"),
    meta: {
      title: "爱心捐赠",
    },
  },
  {
    path: "/about/:id",
    name: "About",
    component: () => import("@/views/about.vue"),
    meta: {
      title: "关于慈福",
    },
  },
  {
    path: "/donateDetail",
    name: "DonateDetail",
    component: () => import("@/views/donateDetail.vue"),
    meta: {
      title: "爱心捐赠",
    },
  },
  {
    path: "/news/:id",
    name: "News",
    component: () => import("@/views/news.vue"),
    meta: {
      title: "慈福新闻",
    },
  },
  {
    path: "/newsDetail",
    name: "News",
    component: () => import("@/views/newsDetail.vue"),
    meta: {
      title: "新闻详情",
    },
  },
  {
    path: "/information/:id",
    name: "Information",
    component: () => import("@/views/information.vue"),
    meta: {
      title: "信息公开",
    },
  },
  {
    path: "/informationDetail",
    name: "Information",
    component: () => import("@/views/informationDetail.vue"),
    meta: {
      title: "信息详情",
    },
  },
  {
    path: "/partyBuilding/:id",
    name: "PartyBuilding",
    component: () => import("@/views/partyBuilding.vue"),
    meta: {
      title: "党建专栏",
    },
  },
  {
    path: "/pdfLook",
    name: "PdfLook",
    component: () => import("@/views/pdfLook.vue"),
    meta: {
      title: "PDF查看",
    },
  },
  {
    path: "/partyBuildingDetail",
    name: "PartyBuilding",
    component: () => import("@/views/partyBuildingDetail.vue"),
    meta: {
      title: "党建详情",
    },
  },
  {
    path: "/joinUs/:id",
    name: "JoinUs",
    component: () => import("@/views/joinUs.vue"),
    meta: {
      title: "加入我们",
    },
  },
];

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => {
    // 忽略重复导航错误
    if (err.name !== "NavigationDuplicated") {
      console.error(err);
    }
  });
};

const router = new VueRouter({
  mode: "hash",
  routes,
  scrollBehavior(to, from, savedPosition) {
    console.log(to, from, savedPosition);
    return { x: 0, y: 0 }; // 始终返回顶部坐标
  }
});

export default router;
